



import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: {}   // { "deviceID_fieldName": "My Friendly Name" }
};

const aliasesSlice = createSlice({
    name: 'aliases',
    initialState,
    reducers: {
        setAliases: (state, action) => {
            state.data = action.payload || {};
        },
        setAlias: (state, action) => {
            const { seriesKey, alias } = action.payload;
            if (alias) {
                state.data[seriesKey] = alias;
            } else {
                delete state.data[seriesKey];
            }
        }
    }
});

export const { setAliases, setAlias } = aliasesSlice.actions;
export default aliasesSlice.reducer;
